module.exports = __webpack_public_path__ + "static/media/trash-undo-alt.d86a1c0a.svg";